import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
// import {  useFormik,  Form, Field } from 'formik';
import ContactDetails from "./Sub Pages/ContactDetails";
import ReferredBy from "./Sub Pages/ReferredBy";
import PersonalAndCompanyDetailsStep from "../../assets/images/personalandcompanydetails-icon.svg";
import LocationStep from "../../assets/images/location-icon.svg";
import ContactStep from "../../assets/images/phone.svg";
import ReferredByStep from "../../assets/images/referredBy_pic.svg";
import PersonalCompanyDetails from "./Sub Pages/PersonalCompanyDetails";
import Location from "./Sub Pages/Location";
import { register } from "../../redux/authSlice";
import { toast } from "react-hot-toast";
import UserRegisteredSuccessfullyModal from "../../components/Modals/UserRegisteredSuccessfullyModal";

// export const icons = [PersonalAndCompanyDetailsStep, LocationStep, ContactStep, ReferredByStep]
export const icons = [
  { icon: PersonalAndCompanyDetailsStep, text: "Personal & Company Details" },
  { icon: LocationStep, text: "Location Details" },
  { icon: ContactStep, text: "Contact Details" },
  { icon: ReferredByStep, text: "Referred By" },
];

const RegistrationStepProgress = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [actionType, setActionType] = useState("add");
  const [registersuccessModalopen, setRegisterSuccessModalOpen] =
    useState(false);

  const handleRegisterSuccessOpen = () => setRegisterSuccessModalOpen(true);
  const handleRegisterSuccessClose = () => setRegisterSuccessModalOpen(false);

  // const handleStepChange = (stepNumber) => {
  //     setCurrentStep(stepNumber)
  // };
  const updateProgressBar = () => ((currentStep - 1) / 3) * 100;

  const [formData, setFormData] = useState({
    PersonalCompanyDetails: {
      uPrefix: "",
      uFirstName: "",
      uLastName: "",
      companyName: "",
      companyTypeName: "",
      companyUrl: "",
      companyDesc: "",
    },
    Location: {
      country: "",
      state: "",
      city: "",
      zip: "",
      companyAddress: "",
    },
    ContactDetails: {
      uIsdCode: "",
      phoneNumber: "",
      uAdditionalPhone: "",
      emailAddress: "",
      companyGst: "",
    },
    ReferredBy: {
      referredName: "",
      referredCompanyName: "",
      referredEmail: "",
      referredPhone: "",
    },
    // companyTypeId:6,
    // emailAddress:"anilksen1@gmail.com",
    uAdditionalPhone: "",
    uNotifyUsersEmail: "",
    isExternal: 0,
    userId: 0,
    latitudeNo: "0",
    longitudeNo: "0",
    isExport: 0,
    parentCompanyId: 0,
    productId: 0,
    companyRolesIds: [],
    conversionFactor: "",
  });

  // const handleNextStep = (stepData) => {
  //     // console.log(stepData ,"handle step console ");
  //     setFormData((prevFormData) => ({
  //         ...prevFormData,
  //         ...stepData,
  //     }));
  //     setCurrentStep((prevStep) => prevStep + 1);

  // };

  // useEffect(() => {
  //     if (currentStep === 5) { // Assuming step 3 is the last step and submission should happen when transitioning to step 4

  //         console.log('MODAL', registersuccessModalopen);
  //         // const{ ...extractedValue} = formData
  //         console.log('Submitting form data:', extractedValue);
  //         const {
  //             PersonalCompanyDetails,
  //             Location,
  //             ContactDetails,
  //             ReferredBy,
  //             ...extractedData
  //         } = formData;
  //         console.log('extracted data value', extractedData)
  //         const RegisterData = {
  //             ...extractedData
  //         }
  //         dispatch(register(
  //             RegisterData
  //         )).then((response) => {
  //             console.log("New User is registered succesfully ", response);

  //             if (response.payload.success === true) {
  //                 handleRegisterSuccessOpen()
  //                 setRegisterSuccessModalOpen(true)
  //                 toast.success(response.payload.msg);
  //                 navigate('/login')
  //             }
  //             else {
  //                 toast.error(response.payload.msg);
  //             }
  //         }).catch((error) => {
  //             console.error("Failed to resigter new user", error);
  //         })
  //     }
  // }, [currentStep, formData, dispatch, registersuccessModalopen]);
  const handleNextStep = (newData, stepName) => {
    const updatedFormData = { ...formData, [stepName]: newData };


      // Flatten the updatedFormData to match the desired payload structure
  const flattenPayload = (payload) => {
    return Object.values(payload).reduce((acc, current) => {
      return { ...acc, ...current };
    }, {});
  };

  const flatPayload = flattenPayload(updatedFormData);
  console.log('Flattened payload:', flatPayload);
    console.log("Submitting form data:", updatedFormData);

    // Check if the current step is the final one
    if (currentStep === 2) {
      // Assuming TOTAL_STEPS is the total number of steps in your form
      // Dispatch the final submission action
      dispatch(submitFinalFormData(flatPayload));
    } else {
      // Not the final step, just update the formData and proceed to the next step
      setFormData(updatedFormData);
      setCurrentStep(currentStep + 1);
    }
  };
  const handleStepChange = (stepNumber, action) => {
    // if (stepNumber >= 1 && stepNumber <= 4) {
    //     setCurrentStep(stepNumber);
    //     setActionType(action);
    // }
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };
  // Navigate back to the previous step
  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const renderStepContent = () => {
    // console.log(currentStep, "current step value");
    switch (currentStep) {
      case 1:
        return (
          <div className="step step-1">
            <PersonalCompanyDetails
              initialValues={formData.PersonalCompanyDetails}
              onSubmit={(data) =>
                handleNextStep(data, "PersonalCompanyDetails")
              }
            />
          </div>
        );
      case 2:
        return (
          <div className="step step-2">
            <Location
              initialValues={formData.Location}
              onSubmit={(data) => handleNextStep(data, "Location")}
              onBack={handleBack}
            />
          </div>
        );
      case 3:
        return (
          <div className="step step-3">
            <ContactDetails
              initialValues={formData.ContactDetails}
              onSubmit={(data) => handleNextStep(data, "ContactDetails")}
              onBack={handleBack}
            //   onSubmit={handleNextStep}
            //   step="ContactDetails"
            //   actionType={actionType}
            //   handleStepChange={handleStepChange}
            //   currentStep={currentStep}
            />
          </div>
        );

      case 4:
        return (
          <div className="step step-4">
            <ReferredBy
              initialValues={formData.referredByDetails}
              onSubmit={(data) => handleNextStep(data, "referredByDetails")}
              onBack={handleBack}
            //   onSubmit={handleNextStep}
            //   step="referredByDetails"
            //   actionType={actionType}
            //   handleStepChange={handleStepChange}
            //   currentStep={currentStep}
            //   registersuccessModalopen={registersuccessModalopen}
            //   handleRegisterSuccessClose={handleRegisterSuccessClose}
            //   handleRegisterSuccessOpen={handleRegisterSuccessOpen}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="login-bg">
      <div className="container p-0">
        <div className="row d-flex justify-content-center align-items-center h-vh">
          <div className="col col-xl-8">
            <div className="card">
              <div className="row g-0">
                <div
                  className="main-content"
                  style={{
                    paddingLeft: "4%",
                    paddingRight: "4%",
                    paddingBottom: "2%",
                  }}
                >
                  {/* Breadcrumb, progress bar, and other UI elements */}
                  <div style={{ paddingLeft: "3%", paddingTop: "3%" }}>
                    <h3>
                      <b>New User Registration</b>{" "}
                    </h3>
                  </div>
                  <div>
                    <div className="card-body">
                      <div
                        className="step-progress"
                        style={{ marginBottom: "5%" }}
                      >
                        <div
                          className="progress px-1"
                          style={{ height: "3px" }}
                        >
                          <div
                            className="progress-bar"
                            role="progressbar"
                            style={{ width: `${updateProgressBar()}%` }}
                            aria-valuenow={updateProgressBar()}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                        <div className="step-container d-flex justify-content-between md-5">
                          {icons.map((step, index) => (
                            <div
                              key={index}
                              className={`step-circle ${
                                currentStep === index + 1 ? "active" : ""
                              }`}
                              onClick={() => handleStepChange(index + 1)}
                            >
                              {/* onClick={() => handleStepChange(index + 1)} */}
                              <img src={step.icon} alt={`Step ${index + 1}`} />
                              <span className="step-text">{step.text}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div id="multi-step-form " className="mt-3">
                        {renderStepContent()}
                      </div>
                    </div>
                    {/* Navigation buttons and other components */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {registersuccessModalopen && (
        <UserRegisteredSuccessfullyModal
          open={registersuccessModalopen}
          handleClose={handleRegisterSuccessClose}
        />
      )}
    </div>
  );
};

export default RegistrationStepProgress;
